var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleSymbolBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137,
    height: 92,
    viewBox: "0 0 137 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:none;stroke:#001f4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 137,
    height: 92,
    rx: 4,
    transform: "translate(784.916 19)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-784.916 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(828.741 57.544) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.423,24.87h0C2.875,24.87,0,22.339,0,19.217V2.261A2.431,2.431,0,0,1,2.569,0H12.846V19.217C12.846,22.339,9.971,24.87,6.423,24.87Z",
    transform: "translate(0 27.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.138,45.217V2.261A2.431,2.431,0,0,1,7.707,0H48.814a2.431,2.431,0,0,1,2.569,2.261V45.217c0,3.746-3.451,6.783-7.707,6.783H0",
    transform: "translate(7.708 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 25.692,
    transform: "translate(23.123 36.174)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 25.692,
    transform: "translate(23.123 42.957)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 30.83,
    height: 15.826,
    transform: "translate(20.554 9.044)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleSymbolBold);
export default __webpack_public_path__ + "static/media/article-symbol-bold.a97d612a048ec80fc5986399078e85f2.svg";
export { ForwardRef as ReactComponent };